module.exports = __webpack_public_path__ + "static/img/video.40f93600.jpg";